import React from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from 'components/tooltip';

import IconFit from 'icons/icon-fit';

const ZoomToFitButton = ({ disabled, onClick }) => {
    const { t } = useTranslation('milestone');

    return (
        <Tooltip tooltip={ t('zoomToFit') }>
            <button className="btn btn-icon btn-icon-large btn-medium btn-secondary btn-border btn-square btn-colored-hover" disabled={disabled} onClick={onClick}>
                <IconFit />
            </button>
        </Tooltip>
    );
}

export default ZoomToFitButton;
